import React, { Component } from "react";
import '../../assets/css/auth.css'
import withNavigate from '../../components/withNavigate'
import { getYear } from "../../settings/shared/commonMethods";
import { APP_VERSION } from "../../settings/shared/constants";
import { Button, Card } from "react-bootstrap";

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            height: window.innerHeight,
        }
    }


    moveToLogin = () => {
        this.props.navigate("/auth/login");
    }




    render() {
        return (<>
            <div>
                <div className="log-top-circle"></div>
                <div className="log-bottom-circle"></div>
                <div className="log-bottom2-circle"></div>

                <div className="auth-footer">
                    <span style={{ color: '#64748b', fontSize: '13px', fontWeight: '400' }}>
                        © {getYear()} SuperAgentX • Version {APP_VERSION}
                    </span>
                </div>
            </div>
            <div className="card-log">
                <Card>
                    <div className="d-flex flex-column">
                        <span className="font-bold font32">Forgot Password</span>
                        <span className="font-regular font10 txt-grey">Please enter your email address you'd like your password reset information sent to</span>
                    </div>

                    <div className="d-flex flex-column mt-3">
                        <span className="font-regular font10">Email</span>
                        <input />
                    </div>

                    <div className="d-flex align-items-center mt-4 justify-content-center">
                        <Button className="w-75 font-semi-bold" type="primary" block>Request reset link</Button>
                    </div>

                    <div className="d-flex align-items-center flex-column mt-3">
                        <span className="font-bold font12 txt-primary action-pointer" onClick={() => this.moveToLogin()}>Back To Login</span>
                    </div>
                </Card>
            </div>
        </>
        )
    }
}



export default withNavigate(ForgotPassword);